import React, { useState, useEffect } from 'react';
import { ChakraProvider, Box, Text } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import ScriptPage from './components/ScriptPage';
import ChangesPage from './components/ChangesPage';
import DataPage from './components/DataPage';

const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [apiStatus, setApiStatus] = useState('loading');

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  useEffect(() => {
    axios.get(`${API_URL}/`)
      .then(() => setApiStatus('online'))
      .catch(() => setApiStatus('offline'));
  }, []);

  return (
    <ChakraProvider>
      <Router>
        {/* <Box p={2} bg="gray.100" textAlign="center">
          {apiStatus === 'loading' && <Text color="gray.500">🔄 Verificando conexión con el servidor...</Text>}
          {apiStatus === 'online' && <Text color="green.600">✅ Conectado con el backend</Text>}
          {apiStatus === 'offline' && <Text color="red.600">❌ No se pudo conectar con el backend</Text>}
        </Box> */}

        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? 
                <Navigate to="/dashboard" /> : 
                <Login onLoginSuccess={handleLoginSuccess} />
            } 
          />
          <Route 
            path="/register" 
            element={
              isAuthenticated ? 
                <Navigate to="/dashboard" /> : 
                <Register />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
                <Dashboard /> : 
                <Navigate to="/" />
            } 
          />
          <Route 
            path="/script/:scriptId" 
            element={
              isAuthenticated ? 
                <ScriptPage /> : 
                <Navigate to="/" />
            } 
          />
          <Route path="/changes" element={<ChangesPage />} />
          <Route path="/data" element={<DataPage />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
